module.exports = __webpack_public_path__ + "static/media/handshake.21cdb589.avif";